export default function evolutionBar() {
    if (document.querySelector(".evolution__item")) {
        let bars = document.querySelectorAll(".bars");

        bars.forEach(bar => {
            bar.children[0].style.width = `${bar.children[0].attributes[1].textContent}%`;
        });
    }
}
